import React from 'react';

const ascii = /^[ -~]+$/;

export const stringHasNonStdAscii = (str) =>
{
  if ( !ascii.test( str ) ) {
    return true;// string has non-ascii characters
  }
  return false;
}

export const findLngLatExtremes = (objects) =>
{
	const returnObj = {latMin:2000, lngMin:2000, latMax:-2000, lngMax:-2000};

	for(var i = 0; i < objects.length; i++)
	{
		const obj = objects[i];

		returnObj.latMin = Math.min(returnObj.latMin, obj.lat);
		returnObj.latMax = Math.max(returnObj.latMax, obj.lat);

		returnObj.lngMin = Math.min(returnObj.lngMin, obj.lng);
		returnObj.lngMax = Math.max(returnObj.lngMax, obj.lng);
	}
	return returnObj;
}

export const findSWNEExtremes = (objects, minDelta = 0.002, padding = 0.1) =>
{
	const extremes = findLngLatExtremes(objects);

	
	const sw = {lng:extremes.lngMin, lat:extremes.latMin};
	const ne = {lng:extremes.lngMax, lat:extremes.latMax};
	
  const diffLng = ne.lng - sw.lng;
  const diffLat = ne.lat - sw.lat;

  if(diffLng < minDelta)
  {
    sw.lng -= (minDelta - diffLng) * 0.5;
    ne.lng += (minDelta - diffLng) * 0.5;
  }

  if(diffLat < minDelta)
  {
    sw.lat -= (minDelta - diffLat) * 0.5;
    ne.lat += (minDelta - diffLat) * 0.5;
  }

  const paddingLat = diffLat * padding;
  const paddingLng = diffLng * padding;

  sw.lat -= paddingLat;
  sw.lng -= paddingLng;

  ne.lat += paddingLat;
  ne.lng += paddingLng;

  const sWNEObject = {
    sw:sw,
    ne:ne
  }
	return sWNEObject;
}

export const getErrorString = (response) =>
{
  var errStr = "";
  for(var i = 0; i < response.error.length; i++)
  {
    errStr += "Err" + i + ": " + response.error[i] + "\n";
  }
  return errStr;
}

export const checkResponseForErr = (reactCompWithState, response, errorKey)=>
{
 if(!response.success && errorKey != null)
 {
    const newErrors = [...reactCompWithState.state[errorKey], ...response.error];
    const newState ={};
    newState["errorKey"] = newErrors;
    reactCompWithState.setState(newState);
 }
 return response.success;
}

export const getSetBaseDataFunc = (thisContext, stateKey, errorKey = "") =>
   {
      const self = thisContext;

      return (response)=>
      {
         //console.log("got generic response: ", response);
         //console.log(response);
         if(response.success)
         {
            const newState = {};
            newState[stateKey] = response.result;
            self.setState(newState);
         }
         else
         {
            self.props.appCallbacks.showResponseErr(response, "Error..." + errorKey + " Getting " + stateKey);
         }
         /*if(checkResponseForErr(self, response, errorKey))
         {
            const newState = {};
            newState[stateKey] = response.result;
            self.setState(newState);
         }*/
      }
   }
export const FreezeElement = (props) =>
{
   return(
      <span>
         {props.value} (Cannot be edited)
      </span>
      );
}

export const filterArrayWhereAllRestrictionsMet = (arr, restrictions) => {
  const filteredArray = [];
  
  for (var i = 0; i < arr.length; i++) {

    const arrObj = arr[i];

    //const arrObjKeys = arr.keys();
    const restrictionKeys = Object.keys(restrictions);

    var restrictionsMet = true;

    for (var j = restrictionKeys.length - 1; j >= 0; j--) {
      const restrictKey = restrictionKeys[j];
      if(!arrObj.hasOwnProperty(restrictKey) ||
        arrObj[restrictKey] != restrictions[restrictKey])
      {
        restrictionsMet = false;
        break;
      }
    }

    if(restrictionsMet)
      filteredArray.push(arrObj);
  }
  return filteredArray;
} 

export const HideValue = (props) =>
{
   return(
      <span>
         {props.value} (Cannot be edited)
      </span>
      );
}


export function makeid(length = 4)
{
    var text = "";
    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";

    for( var i=0; i < length; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

export function setsAreEqual(as, bs) {
    if (as.size !== bs.size) return false;
    for (var a of as) if (!bs.has(a)) return false;
    return true;
}

export const ImmutableValue = (props) =>
{
   return(
      <span>
         {props.value} (Cannot be edited)
      </span>
      );
}


// WEBPACK FOOTER //
// ./js/tools.jsx